import { Card, CardContent, Stack, Typography } from '@mui/material';
import LoginBg from '@/assets/images/LoginBg.png';

interface AuthCardProps {
	title: string;
	message: string;
	cardContentStyle?: React.CSSProperties;
}

export default function AuthCard(
	props: React.PropsWithChildren<AuthCardProps>
) {
	return (
		<>
			<Stack
				width='100%'
				maxWidth='960px'
				marginX='10px'
				alignItems='center'
				display='flex'
				position='relative'
			>
				<Card
					sx={{
						width: '100%',
						display: 'flex',
						borderTopLeftRadius: '50px',
						borderBottomLeftRadius: '50px',
					}}
				>
					<img src={LoginBg} style={{ width: '320px', height: '500px' }} />
					<CardContent
						sx={{ flex: 1, padding: '54px 64px' }}
						style={props.cardContentStyle}
					>
						<Typography
							fontSize='36px'
							variant='bold'
							marginTop='22px'
							whiteSpace='nowrap'
						>
							{props.title}
						</Typography>
						<Typography
							fontSize='body2'
							marginTop='7px'
							color='common.neutral50'
						>
							{props.message}
						</Typography>
						{props.children}
					</CardContent>
				</Card>
			</Stack>
		</>
	);
}
